import http from "@/utils/http";


export const DeviceUserTimeRuleApi = {
  //获取简单列表（全部规则）
  insert(data){
    return http.post(`/nexus/acsDeviceUserRule/insert` ,data)
  },
  //根据用户ID查询设备规则信息
  queryByUserId(userId){
    return http.get(`/nexus/acsDeviceUserRule/query/${userId}`)
  },
  //删除设备用户规则
  deleteById(data){
    return http.post(`/nexus/acsDeviceUserRule/delete`,data)
  },
  batchDelete(data){
    return http.post(`/nexus/acsDeviceUserRule/batchDelete`,data)
  },
  queryPage(param){
    return http.get(`/nexus/acsDeviceUserRule/page`,param)
  }
}
